/** Sort eligible stock FIFO: oldest received first. */
export function sortFifo<T extends { received_at?: string | null; created_at?: string | null }>(
  rows: T[],
): T[] {
  return [...rows].sort((a, b) => {
    const ar = a.received_at || a.created_at || "";
    const br = b.received_at || b.created_at || "";
    if (ar !== br) return ar < br ? -1 : 1;
    const ac = a.created_at || "";
    const bc = b.created_at || "";
    return ac < bc ? -1 : ac > bc ? 1 : 0;
  });
}

export function allocateFifo<T extends { weight: number; id: string }>(
  stock: T[],
  needWeight: number,
): { batchId: string; takeWeight: number }[] {
  const sorted = sortFifo(stock as (T & { received_at?: string })[]);
  let left = needWeight;
  const out: { batchId: string; takeWeight: number }[] = [];
  for (const b of sorted) {
    if (left <= 1e-6) break;
    const take = Math.min(b.weight, left);
    if (take > 1e-6) {
      out.push({ batchId: b.id, takeWeight: take });
      left -= take;
    }
  }
  return out;
}
